export default "__VITE_ASSET__09a5134b__"